/* kesser-cache-bust:20260915085515 */
/* Kesser theme JS — cart drawer, menu drawer, product form, quantity */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  var moneyFormat = window.themeMoneyFormat || '{{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  /* Free-shipping threshold mirrors the store's active "FRETE GRÁTIS" automatic
     discount (subtotal >= R$400,00) — keep in sync if that discount ever changes. */
  var FREE_SHIPPING_THRESHOLD_CENTS = 40000;

  function updateShippingProgress(cart) {
    var msgEl = qs('[data-cart-shipping-msg]');
    var fillEl = qs('[data-cart-shipping-fill]');
    if (!msgEl || !fillEl) return;
    var remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;
    var pct = Math.min(100, Math.max(0, (cart.total_price / FREE_SHIPPING_THRESHOLD_CENTS) * 100));
    fillEl.style.width = pct + '%';
    if (remaining <= 0) {
      msgEl.innerHTML = 'Você ganhou <strong>frete grátis!</strong>';
    } else {
      msgEl.innerHTML = 'Faltam <strong>' + formatMoney(remaining) + '</strong> para você ganhar <strong>frete grátis</strong>!';
    }
  }

  var WELCOME_AUTO_CODES = ['BEMVINDAKESSER', 'PRIMEIRACOMPRA', 'BOASVINDASKESSER', 'ZOPPY', 'BOASVINDAS'];

  function collectAppliedDiscounts(cart) {
    // Use only cart-level applications to avoid double-counting line allocations.
    var rows = [];
    var codeHints = (cart.discount_codes || []).map(function (c) {
      return String(c.code || '').toUpperCase();
    }).filter(Boolean);

    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var amount = Number(d.total_allocated_amount || 0);
      var title = d.title || d.code || d.description || '';
      title = String(title || '').trim();
      if (!title || title === 'undefined' || title === 'null') {
        title = codeHints[0] || 'Desconto';
      }
      // Skip ghost rows (undefined label + R$0) that confuse the UI.
      if (amount <= 0 && (!d.title || String(d.title) === 'undefined')) return;
      rows.push({
        title: title,
        amount: amount,
        type: d.type || 'discount_code'
      });
    });
    return rows;
  }

  function updateDiscountDisplay(cart) {
    var lineEl = qs('[data-cart-discount-line]');
    var amountEl = qs('[data-cart-discount-amount]');
    var listEl = qs('[data-cart-discount-list]');
    if (!lineEl || !amountEl) return;

    var rows = collectAppliedDiscounts(cart);
    var giftPending = (cart.items || []).reduce(function (sum, item) {
      return sum + giftLinePendingAmount(item);
    }, 0);
    if (giftPending > 0) {
      rows.push({ title: 'Brinde Dia do Cliente', amount: giftPending, type: 'automatic' });
    }

    var total = cartDisplayTotalDiscount(cart);
    if (listEl) {
      if (!rows.length) {
        listEl.innerHTML = total > 0
          ? '<li class="cart-drawer__discount-item"><span class="cart-drawer__discount-name">Desconto aplicado</span><span class="cart-drawer__discount-value">-' + formatMoney(total) + '</span></li>'
          : '';
      } else {
        listEl.innerHTML = rows.map(function (d) {
          var name = String(d.title || 'Desconto');
          if (name === 'undefined' || name === 'null') name = 'Desconto';
          var tag = d.type === 'automatic' ? ' <em>(automático)</em>' : '';
          return '<li class="cart-drawer__discount-item"><span class="cart-drawer__discount-name">' +
            name + tag +
            '</span><span class="cart-drawer__discount-value">-' + formatMoney(d.amount) +
            '</span></li>';
        }).join('');
      }
    }

    if (total > 0 || rows.length) {
      amountEl.textContent = '-' + formatMoney(total);
      lineEl.hidden = false;
    } else {
      amountEl.textContent = '';
      lineEl.hidden = true;
    }
  }

  function clearCartDiscountCodes() {
    // Prefer Ajax clear; /discount/CLEAR as fallback (cookie / storefront discount).
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) { return r.json(); })
      .catch(function () {
        return fetch('/discount/CLEAR', { credentials: 'same-origin' })
          .catch(function () {})
          .then(function () { return fetchCart(); });
      });
  }

  function cartHasWelcomeAutoCode(cart) {
    var codes = (cart.discount_codes || []).map(function (c) {
      return String(c.code || '').toUpperCase();
    });
    var titles = (cart.cart_level_discount_applications || []).map(function (d) {
      return String(d.title || d.code || '').toUpperCase();
    });
    var all = codes.concat(titles);
    return all.some(function (code) {
      return WELCOME_AUTO_CODES.indexOf(code) !== -1;
    });
  }

  // Welcome codes stick only after "Aplicar" in this page lifetime — not via cookie/link alone.
  var manualDiscountCode = '';

  function getManualDiscountCode() {
    return String(manualDiscountCode || '').toUpperCase();
  }

  function stripUnwantedWelcomeDiscounts(cart) {
    var codes = (cart.discount_codes || []).map(function (c) {
      return String(c.code || '').toUpperCase();
    });
    var userCode = getManualDiscountCode();

    var unwanted = codes.filter(function (code) {
      if (WELCOME_AUTO_CODES.indexOf(code) === -1) return false;
      return userCode !== code;
    });

    if (!unwanted.length && cartHasWelcomeAutoCode(cart)) {
      var keep = userCode && WELCOME_AUTO_CODES.indexOf(userCode) !== -1;
      if (!keep) unwanted = ['WELCOME'];
    }

    if (!unwanted.length) return Promise.resolve(cart);

    // Clear Shopify discount cookie, then Ajax cart discount.
    return fetch('/discount/CLEAR', { credentials: 'same-origin' })
      .catch(function () {})
      .then(function () { return clearCartDiscountCodes(); })
      .then(function (fresh) {
        if (fresh && cartHasWelcomeAutoCode(fresh) && getManualDiscountCode() === '') {
          return fetch('/discount/CLEAR', { credentials: 'same-origin' })
            .catch(function () {})
            .then(function () { return clearCartDiscountCodes(); });
        }
        return fresh;
      })
      .then(function (fresh) { return fresh && fresh.items ? fresh : fetchCart(); })
      .catch(function () { return cart; });
  }

  /* ---------------- Menu drawer ---------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-menu-open]');
    if (opener) {
      var drawer = qs('#MenuDrawer');
      if (drawer) { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    }
    var closer = e.target.closest('[data-menu-close]');
    if (closer) {
      var d = qs('#MenuDrawer');
      if (d) { d.removeAttribute('open'); document.body.style.overflow = ''; }
    }
  });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = qs('#CartDrawer');

  function openCartDrawer() {
    if (cartDrawer) { cartDrawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
  }
  function closeCartDrawer() {
    if (cartDrawer) { cartDrawer.removeAttribute('open'); document.body.style.overflow = ''; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.closest('[data-cart-close]')) {
      closeCartDrawer();
    }
  });


  function isLockedGiftLine(item) {
    // Only the campaign gift line (marked by JS). Paid purchases of the same SKU stay editable.
    var props = item.properties || {};
    return String(props._kesser_auto_gift) === '1' || String(props._kesser_ep_gift) === '1';
  }

  function isCampaignGiftItem(item) {
    // ONLY lines explicitly marked by kesser-auto-gift.js.
    // Never treat Admin BXGY / discount titles as gifts — that inverted paid All Clean to free.
    var props = item.properties || {};
    return String(props._kesser_auto_gift) === '1' || String(props._kesser_ep_gift) === '1';
  }

  function isDiaDoClienteDiscountTitle(title) {
    return String(title || '').indexOf('Dia do Cliente') !== -1;
  }

  function campaignDiscountOnPaidLine(item) {
    // Admin BXGY may attach to paid same-SKU lines; those cents must stay "paid" in the UI.
    if (!item || isCampaignGiftItem(item)) return 0;
    var amount = 0;
    var discs = item.discounts || [];
    for (var i = 0; i < discs.length; i += 1) {
      if (isDiaDoClienteDiscountTitle(discs[i].title)) {
        amount += Number(discs[i].amount || 0);
      }
    }
    var allocs = item.line_level_discount_allocations || [];
    for (var j = 0; j < allocs.length; j += 1) {
      var app = allocs[j].discount_application || allocs[j].discountApplication || {};
      var title = app.title || (allocs[j].discount && allocs[j].discount.title) || '';
      if (isDiaDoClienteDiscountTitle(title)) {
        amount += Number(allocs[j].amount || 0);
      }
    }
    // Fallback: fully/partly zeroed paid gift-SKU with no structured discount payload.
    if (amount <= 0) {
      var original = Number(item.original_line_price != null ? item.original_line_price : (item.original_price || item.price || 0) * (item.quantity || 1));
      var final = Number(item.final_line_price != null ? item.final_line_price : 0);
      if (original > final && final === 0 && Number(item.total_discount || 0) > 0) {
        // Only reclaim when a campaign-looking discount is present on the item.
        var anyTitle = discs.concat(allocs.map(function (a) {
          var d = a.discount_application || {};
          return { title: d.title };
        }));
        for (var k = 0; k < anyTitle.length; k += 1) {
          if (isDiaDoClienteDiscountTitle(anyTitle[k].title)) {
            amount = original - final;
            break;
          }
        }
      }
    }
    return amount;
  }

  function paidLineDisplayUnitPrice(item) {
    var stolen = campaignDiscountOnPaidLine(item);
    if (stolen > 0) {
      return Number(item.original_price || item.price || 0);
    }
    return Number(item.final_price != null ? item.final_price : item.price || 0);
  }


  function cartLineQtyHtml(item) {
    if (isLockedGiftLine(item)) {
      return '';
    }
    return (
      '<div class="cart-line__qty">' +
        '<button type="button" class="qty-btn" data-cart-qty-decrease data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Diminuir">-</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" class="qty-btn" data-cart-qty-increase data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Aumentar">+</button>' +
      '</div>'
    );
  }


  function giftLinePendingAmount(item) {
    // Pending charge only for lines with properties._kesser_auto_gift === '1'.
    // Never keys off Dia do Cliente discount titles (those can appear on paid Duo in checkout).
    if (!isCampaignGiftItem(item)) return 0;
    return Number(item.final_line_price || item.line_price || 0);
  }

  function cartDisplayTotalPrice(cart) {
    var giftPending = (cart.items || []).reduce(function (sum, item) {
      return sum + giftLinePendingAmount(item);
    }, 0);
    // Add back campaign cents wrongly applied to paid (non-_kesser_auto_gift) lines.
    var stolen = (cart.items || []).reduce(function (sum, item) {
      return sum + campaignDiscountOnPaidLine(item);
    }, 0);
    return Math.max(0, Number(cart.total_price || 0) - giftPending + stolen);
  }

  function cartDisplayTotalDiscount(cart) {
    var giftPending = (cart.items || []).reduce(function (sum, item) {
      return sum + giftLinePendingAmount(item);
    }, 0);
    var stolen = (cart.items || []).reduce(function (sum, item) {
      return sum + campaignDiscountOnPaidLine(item);
    }, 0);
    // Show gift as discount; hide campaign discount that inverted onto paid lines.
    return Math.max(0, Number(cart.total_discount || 0) + giftPending - stolen);
  }

  function cartLinePriceHtml(item) {
    var isGift = isCampaignGiftItem(item);
    var original = item.original_price || item.price;

    // UI always shows campaign gifts as free. Real checkout zeros via Admin BXGY
    // when the campaign window is active; until then this is display-only.
    if (isGift) {
      return (
        '<div class="cart-line__price cart-line__price--gift">' +
          '<s>' + formatMoney(original) + '</s> ' +
          '<strong>R$ 0,00</strong>' +
          '<span class="cart-line__gift-tag">Brinde</span>' +
        '</div>'
      );
    }
    // Paid lines: never appear free because of Dia do Cliente BXGY mis-allocation.
    return '<div class="cart-line__price">' + formatMoney(paidLineDisplayUnitPrice(item)) + '</div>';
  }

  function renderCartDrawer(cart) {
    // Always merge before paint — never skip via __kesserMerged (false-positive caused 1+3 splits).
    return mergeDuplicateCartLines(cart).then(function (merged) {
      var c = merged || cart;
      if (!c || c.__kesserWelcomeChecked) {
        return renderCartDrawerDraw(c);
      }
      return stripUnwantedWelcomeDiscounts(c).then(function (fresh) {
        fresh = fresh || c;
        fresh.__kesserWelcomeChecked = true;
        return renderCartDrawerDraw(fresh);
      });
    });
  }

  function renderCartDrawerDraw(cart) {
    var root = qs('#CartDrawerContent');
    if (!root) return;

    var footerEl = qs('[data-cart-footer]');

    qsa('[data-cart-count-bubble]').forEach(function (el) { el.textContent = cart.item_count; });
    var mobileBubble = qs('[data-cart-count-bubble-mobile]');
    if (mobileBubble) {
      mobileBubble.textContent = cart.item_count;
      mobileBubble.hidden = cart.item_count === 0;
    }

    updateShippingProgress(cart);

    if (cart.item_count === 0) {
      root.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p>' + (window.themeStrings.cartEmpty || 'Sua sacola está vazia') + '</p>' +
        '<a href="/collections/all" class="button">' + (window.themeStrings.continueShopping || 'Continuar comprando') + '</a>' +
        '</div>';
      if (footerEl) footerEl.hidden = true;
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      return (
        '<div class="cart-line' + (isLockedGiftLine(item) ? ' cart-line--gift' : '') + '" data-line-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-line__image">' +
            (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy">' : '') +
          '</a>' +
          '<div>' +
            '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
            (item.variant_title ? '<div class="cart-line__price">' + item.variant_title + '</div>' : '') +
            cartLinePriceHtml(item) +
            cartLineQtyHtml(item) +
            (isLockedGiftLine(item)
              ? ''
              : '<button type="button" class="cart-line__remove" data-cart-remove data-key="' + item.key + '">' + (window.themeStrings.remove || 'Remover') + '</button>') +
          '</div>' +
        '</div>'
      );
    }).join('');

    root.innerHTML = itemsHtml;

    if (footerEl) footerEl.hidden = false;

    var subtotalEl = qs('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cartDisplayTotalPrice(cart));

    updateDiscountDisplay(cart);
  }


  function isPaidCartLine(item) {
    var props = item.properties || {};
    return String(props._kesser_auto_gift) !== '1' && String(props._kesser_ep_gift) !== '1';
  }

  function mergeDuplicateCartLines(cart) {
    // Paid lines: merge by variant_id ONLY (ignore empty vs missing properties).
    // Gift lines stay untouched / separate from paid units of the same SKU.
    if (!cart || !cart.items || cart.items.length < 2) return Promise.resolve(cart);
    var groups = {};
    cart.items.forEach(function (item) {
      if (!isPaidCartLine(item)) return;
      var sig = String(item.variant_id);
      if (!groups[sig]) groups[sig] = [];
      groups[sig].push(item);
    });
    var updates = {};
    var need = false;
    Object.keys(groups).forEach(function (sig) {
      var lines = groups[sig];
      if (lines.length < 2) return;
      need = true;
      var total = 0;
      lines.forEach(function (l) { total += Number(l.quantity || 0); });
      updates[lines[0].key] = total;
      for (var i = 1; i < lines.length; i++) updates[lines[i].key] = 0;
    });
    if (!need) return Promise.resolve(cart);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function waitForGifts(cartHint) {
    var p = (window.KesserGifts && typeof window.KesserGifts.ensureReady === 'function')
      ? window.KesserGifts.ensureReady(cartHint)
      : Promise.resolve(cartHint);
    // Eye Patch Lip Oil promo ended 2026-10-20 12:00 SP: no extra gift step.
    return p;
  }

  function refreshCart() {
    return enqueueCartMutation(function () {
      return waitForGifts()
        .then(function (cart) {
          return cart && cart.items ? cart : fetchCart();
        })
        .then(function (cart) {
          if (cart) delete cart.__kesserWelcomeChecked;
          return renderCartDrawer(cart);
        });
    });
  }

  // Zoppy (or similar) may re-apply welcome codes after our clear — keep stripping.
  setInterval(function () {
    if (!cartDrawer || !cartDrawer.hasAttribute('open')) return;
    fetchCart().then(function (cart) {
      if (!cart || !cartHasWelcomeAutoCode(cart)) return;
      var userCode = getManualDiscountCode();
      var codes = (cart.discount_codes || []).map(function (c) { return String(c.code || '').toUpperCase(); });
      var needs = codes.some(function (c) { return WELCOME_AUTO_CODES.indexOf(c) !== -1 && c !== userCode; });
      if (!needs && !(!userCode && cartHasWelcomeAutoCode(cart))) return;
      delete cart.__kesserWelcomeChecked;
      renderCartDrawer(cart);
    }).catch(function () {});
  }, 2500);

  document.addEventListener('DOMContentLoaded', refreshCart);

  /* Fired by assets/kesser-auto-gift.js after it silently adds/removes the automatic
     gift-with-purchase line via its own fetch calls, so the drawer reflects that change
     without waiting for the shopper's own next cart action. */
  document.addEventListener('cart:updated', refreshCart);

  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]');
    if (incBtn) {
      var key = incBtn.getAttribute('data-key');
      var qty = parseInt(incBtn.getAttribute('data-qty'), 10);
      updateCartLine(key, Math.max(0, qty));
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      updateCartLine(removeBtn.getAttribute('data-key'), 0);
    }
  });

  // Serialize cart mutations so qty clicks / gift sync / add never interleave into split lines.
  var cartMutationQueue = Promise.resolve();
  function enqueueCartMutation(task) {
    cartMutationQueue = cartMutationQueue
      .then(task)
      .catch(function (err) { console.error(err); });
    return cartMutationQueue;
  }

  function updateCartLine(key, quantity) {
    // Do not paint the intermediate cart (pre-gift). Merge after gift sync, then one redraw.
    return enqueueCartMutation(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return waitForGifts(); })
        .then(function (cart) {
          return cart && cart.items ? cart : fetchCart();
        })
        .then(function (cart) {
          if (cart) delete cart.__kesserWelcomeChecked;
          return renderCartDrawer(cart);
        });
    });
  }


  /* ---------------- Cart drawer: CEP shipping calculator ---------------- */
  function normalizeCep(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCepDisplay(cep) {
    var d = normalizeCep(cep);
    if (d.length > 5) return d.slice(0, 5) + '-' + d.slice(5);
    return d;
  }

  /* Fallback CEP→UF when ViaCEP is unavailable (prefix ranges, IBGE/Correios). */
  function ufFromCepFallback(cep) {
    var n = parseInt(normalizeCep(cep), 10);
    if (!n || normalizeCep(cep).length !== 8) return null;
    var ranges = [
      [1000000, 19999999, 'SP'],
      [20000000, 28999999, 'RJ'],
      [29000000, 29999999, 'ES'],
      [30000000, 39999999, 'MG'],
      [40000000, 48999999, 'BA'],
      [49000000, 49999999, 'SE'],
      [50000000, 56999999, 'PE'],
      [57000000, 57999999, 'AL'],
      [58000000, 58999999, 'PB'],
      [59000000, 59999999, 'RN'],
      [60000000, 63999999, 'CE'],
      [64000000, 64999999, 'PI'],
      [65000000, 65999999, 'MA'],
      [66000000, 68899999, 'PA'],
      [68900000, 68999999, 'AP'],
      [69000000, 69299999, 'AM'],
      [69300000, 69399999, 'RR'],
      [69400000, 69899999, 'AM'],
      [69900000, 69999999, 'AC'],
      [70000000, 72799999, 'DF'],
      [72800000, 72999999, 'GO'],
      [73000000, 73699999, 'DF'],
      [73700000, 76799999, 'GO'],
      [76800000, 76999999, 'RO'],
      [77000000, 77999999, 'TO'],
      [78000000, 78899999, 'MT'],
      [79000000, 79999999, 'MS'],
      [80000000, 87999999, 'PR'],
      [88000000, 89999999, 'SC'],
      [90000000, 99999999, 'RS']
    ];
    for (var i = 0; i < ranges.length; i++) {
      if (n >= ranges[i][0] && n <= ranges[i][1]) return ranges[i][2];
    }
    return null;
  }

  function resolveProvinceFromCep(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && !data.erro && data.uf) {
          return { province: String(data.uf).toUpperCase(), city: data.localidade || '', source: 'viacep' };
        }
        var uf = ufFromCepFallback(cep);
        if (uf) return { province: uf, city: '', source: 'fallback' };
        throw new Error('CEP_NOT_FOUND');
      })
      .catch(function () {
        var uf = ufFromCepFallback(cep);
        if (uf) return { province: uf, city: '', source: 'fallback' };
        throw new Error('CEP_LOOKUP_FAILED');
      });
  }

  function buildShippingAddressParams(cep, province) {
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', cep);
    params.set('shipping_address[country]', 'Brazil');
    params.set('shipping_address[province]', province);
    return params.toString();
  }

  function prepareShippingRates(cep, province) {
    var qs = buildShippingAddressParams(cep, province);
    return fetch('/cart/prepare_shipping_rates.json?' + qs, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
  }

  function fetchClassicShippingRates(cep, province) {
    var qs = buildShippingAddressParams(cep, province);
    return fetch('/cart/shipping_rates.json?' + qs, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function pollAsyncShippingRates(attempt) {
    attempt = attempt || 0;
    return fetch('/cart/async_shipping_rates.json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json().then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        if (rates.length) return data;
        // Still computing — poll a few times.
        if (attempt < 12 && data && (data.shipping_rates === undefined || data.shipping_rates === null || (Array.isArray(rates) && !data.error))) {
          // Empty array after prepare can mean pending OR no rates; keep polling briefly.
          if (attempt < 8) {
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                pollAsyncShippingRates(attempt + 1).then(resolve, reject);
              }, 350);
            });
          }
        }
        return data || { shipping_rates: [] };
      });
    });
  }

  function formatDeliveryDays(rate) {
    var days = rate && rate.delivery_days;
    if (!days || !days.length) return '';
    var a = Number(days[0]);
    var b = Number(days[days.length - 1]);
    if (!isFinite(a)) return '';
    if (!isFinite(b) || a === b) {
      return a === 1 ? '1 dia útil' : a + ' dias úteis';
    }
    return a + '–' + b + ' dias úteis';
  }

  function renderShippingRates(resultsEl, rates, cartTotalCents) {
    if (!resultsEl) return;
    resultsEl.hidden = false;
    var qualifiesFree = Number(cartTotalCents || 0) >= FREE_SHIPPING_THRESHOLD_CENTS;
    var note = qualifiesFree
      ? '<p class="cart-drawer__shipping-free-note">Seu pedido qualifica para <strong>frete grátis</strong> (a partir de ' + formatMoney(FREE_SHIPPING_THRESHOLD_CENTS) + '). O desconto é aplicado no checkout.</p>'
      : '';

    if (!rates || !rates.length) {
      resultsEl.innerHTML = note + '<p class="cart-drawer__shipping-error">Nenhuma opção de frete encontrada para este CEP.</p>';
      return;
    }

    var list = rates.map(function (rate) {
      var name = rate.presentment_name || rate.name || 'Frete';
      var priceNum = parseFloat(rate.price);
      var priceLabel = (!isFinite(priceNum) || priceNum === 0) ? 'Grátis' : formatMoney(Math.round(priceNum * 100));
      var days = formatDeliveryDays(rate);
      return (
        '<li class="cart-drawer__shipping-rate">' +
          '<span class="cart-drawer__shipping-rate-name">' + name + (days ? ' · ' + days : '') + '</span>' +
          '<span class="cart-drawer__shipping-rate-price">' + priceLabel + '</span>' +
        '</li>'
      );
    }).join('');

    resultsEl.innerHTML = note + '<ul class="cart-drawer__shipping-rate-list">' + list + '</ul>';
  }

  function showShippingError(resultsEl, message) {
    if (!resultsEl) return;
    resultsEl.hidden = false;
    resultsEl.innerHTML = '<p class="cart-drawer__shipping-error">' + message + '</p>';
  }

  function calculateCartShipping() {
    var input = qs('[data-cart-cep-input]');
    var btn = qs('[data-cart-cep-submit]');
    var resultsEl = qs('[data-cart-shipping-results]');
    if (!input || !resultsEl) return;

    var cep = normalizeCep(input.value);
    input.value = formatCepDisplay(cep);

    if (cep.length !== 8) {
      showShippingError(resultsEl, 'Digite um CEP válido com 8 dígitos.');
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    resultsEl.hidden = false;
    resultsEl.innerHTML = '<p class="cart-drawer__shipping-loading">Calculando frete…</p>';

    var cartTotalPromise = fetchCart().then(function (cart) {
      return cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    }).catch(function () { return 0; });

    resolveProvinceFromCep(cep)
      .then(function (geo) {
        return prepareShippingRates(cep, geo.province)
          .then(function () { return pollAsyncShippingRates(0); })
          .then(function (asyncData) {
            var rates = (asyncData && asyncData.shipping_rates) || [];
            if (rates.length) return { rates: rates, province: geo.province };
            // Fallback: classic sync endpoint (worked in storefront diagnosis).
            return fetchClassicShippingRates(cep, geo.province).then(function (classic) {
              return { rates: (classic && classic.shipping_rates) || [], province: geo.province };
            });
          });
      })
      .then(function (result) {
        return cartTotalPromise.then(function (total) {
          renderShippingRates(resultsEl, result.rates, total);
        });
      })
      .catch(function (err) {
        var msg = 'Não foi possível calcular o frete agora. Tente novamente.';
        if (err && (err.message === 'CEP_NOT_FOUND' || err.message === 'CEP_LOOKUP_FAILED')) {
          msg = 'CEP não encontrado. Confira o número e tente de novo.';
        }
        showShippingError(resultsEl, msg);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-cep-input]')) return;
    var digits = normalizeCep(e.target.value);
    var formatted = formatCepDisplay(digits);
    if (e.target.value !== formatted) {
      var start = e.target.selectionStart;
      e.target.value = formatted;
      // Keep caret near end for simple mask.
      try { e.target.setSelectionRange(formatted.length, formatted.length); } catch (err) {}
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.matches('[data-cart-cep-input]')) return;
    e.preventDefault();
    calculateCartShipping();
  });

  document.addEventListener('click', function (e) {
    var cepBtn = e.target.closest('[data-cart-cep-submit]');
    if (!cepBtn) return;
    e.preventDefault();
    calculateCartShipping();
  });

  /* ---------------- Cart drawer: discount code ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target.matches('[data-cart-discount-input]')) {
      e.preventDefault();
      var discountWrap = e.target.closest('.cart-drawer__discount');
      var applyBtn = discountWrap && discountWrap.querySelector('[data-cart-discount-submit]');
      if (applyBtn) applyBtn.click();
    }
  });

  document.addEventListener('click', function (e) {
    var discountBtn = e.target.closest('[data-cart-discount-submit]');
    if (!discountBtn) return;
    var wrap = discountBtn.closest('.cart-drawer__discount');
    var input = wrap.querySelector('[data-cart-discount-input]');
    var msgEl = wrap.querySelector('[data-cart-discount-message]');
    var code = (input.value || '').trim();
    if (!code) return;

    discountBtn.disabled = true;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        manualDiscountCode = code.toUpperCase();
        try { sessionStorage.setItem('kesser_user_discount', manualDiscountCode); } catch (err) {}
        cart.__kesserWelcomeChecked = true;
        renderCartDrawer(cart);
        var applied = (cart.discount_codes || []).some(function (d) {
          return String(d.code || '').toUpperCase() === code.toUpperCase();
        });
        if (applied || cart.total_discount > 0) {
          msgEl.textContent = 'Cupom aplicado!';
          input.value = '';
        } else {
          msgEl.textContent = 'Cupom inválido ou não aplicável.';
        }
        msgEl.hidden = false;
      })
      .catch(function () {
        msgEl.textContent = 'Não foi possível aplicar o cupom agora.';
        msgEl.hidden = false;
      })
      .finally(function () {
        discountBtn.disabled = false;
      });
  });

  /* ---------------- Add to cart (product form) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '...'; }

    var formData = new FormData(form);

    enqueueCartMutation(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          return waitForGifts();
        })
        .then(function (cart) {
          return cart && cart.items ? cart : fetchCart();
        })
        .then(function (cart) {
          if (cart) delete cart.__kesserWelcomeChecked;
          openCartDrawer();
          return renderCartDrawer(cart);
        })
        .catch(function (err) {
          alert((err && err.description) || 'Não foi possível adicionar o produto.');
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        });
    });
  });

  /* ---------------- Quantity selector (product page) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-change]');
    if (!btn) return;
    var wrapper = btn.closest('.quantity-selector');
    var input = wrapper.querySelector('input[name="quantity"]');
    var delta = parseInt(btn.getAttribute('data-quantity-change'), 10);
    var newVal = Math.max(1, parseInt(input.value || '1', 10) + delta);
    input.value = newVal;
  });

  /* ---------------- Variant picker + product gallery: handled by kesser-product-page.js (fixes image/variant sync bugs) ---------------- */

  /* ---------------- Product card hover "confira" cursor-follow (collection/grid cards) ---------------- */
  qsa('[data-card-hover]').forEach(function (el) {
    var cta = el.querySelector('.card-product__hover-cta');
    if (!cta) return;
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      cta.style.left = (e.clientX - rect.left) + 'px';
      cta.style.top = (e.clientY - rect.top) + 'px';
    });
  });

  /* ---------------- Newsletter form feedback ---------------- */
  qsa('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var msg = qs('[data-newsletter-message]', form.parentElement);
      if (msg) msg.hidden = false;
    });
  });
})();
